import React from 'react';
import { connect } from 'react-redux';

import ActionButton from 'jbc-front/components/ActionButton';
import PdfFile from 'jbc-front/components/icons/PdfFile';
import { formatDate } from 'src/utils/Date';
import { getOptionLabel, getGroupFullPathName } from 'src/utils/Utils';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { CheckboxFieldWithoutForm } from 'src/components';
import PreviewPdfModalContainer from 'src/containers/PreviewPdfModalContainer';
import { changeChecked } from 'src/reducers/reports/reportWageLedger';
import { WAGE_LEDGER_PERSONAL_PDF } from 'src/constants/EndpointUrls';

import styles from './ReportWageLedgerTable.scss';

class ReportWageLedgerTableRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPdfPreview: false
    };
  }

  showPreview = (year, employeeId) => {
    this.setState({ ...this.state, isPdfPreview: true, year, employeeId });
  };
  hidePreview = () => {
    this.setState({ ...this.state, isPdfPreview: false });
  };
  personalPdfUrl = (year, employeeId) => `${WAGE_LEDGER_PERSONAL_PDF}?employee_ids=${employeeId}&year=${year}`;

  render() {
    const {
      year,
      checked,
      id,
      staffCode,
      name,
      employmentTypeId,
      groupId,
      joinedOn,
      resignedOn,
      groups,
      clientEmploymentTypes,
      onChageCheckedClick
    } = this.props;
    const tdClass = checked ? 'm-table-checkbox-on' : 'm-table-checkbox-off';
    const trClass = checked ? styles.abled : styles.disabled;

    return (
      <tr className={'table-hover'}>
        <td
          role="presentation"
          className={tdClass}
          onClick={e => {
            e.stopPropagation();
            onChageCheckedClick(id);
          }}
        >
          <CheckboxFieldWithoutForm checked={checked} readOnly={'readonly'} />
        </td>
        <td className={`${trClass}`}>{staffCode}</td>
        <td className={`${trClass}`}>{name}</td>
        <td className={`${trClass}`}>{getOptionLabel(employmentTypeId)(clientEmploymentTypes)}</td>
        <td className={`${trClass}`}>{!!groupId && <div>{getGroupFullPathName(groups, groupId)}</div>}</td>
        <td className={`${trClass}`}>{formatDate(joinedOn)}</td>
        <td className={`${trClass}`}>{formatDate(resignedOn)}</td>
        <td className={`${styles.abled}`}>
          <ActionButton
            primary
            icon={<PdfFile size={18} />}
            onClick={() => {
              this.showPreview(year, id);
            }}
          >
            PDF出力
          </ActionButton>
        </td>
        {this.state.isPdfPreview && (
          <PreviewPdfModalContainer
            header="賃金台帳"
            isOpen={this.state.isPdfPreview}
            hideModal={this.hidePreview}
            url={this.personalPdfUrl(this.state.year, this.state.employeeId)}
            downloadUrl={this.personalPdfUrl(this.state.year, this.state.employeeId)}
          />
        )}
      </tr>
    );
  }
}

export default connect(
  state => ({
    groups: getSelectOptions(state, 'groups'),
    clientEmploymentTypes: getSelectOptions(state, 'employmentTypes')
  }),
  dispatch => ({
    onChageCheckedClick: id => dispatch(changeChecked(id))
  })
)(ReportWageLedgerTableRow);
